import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=7f8a00cd&scoped=true"
import script from "./BillInfo.ts?vue&type=script&lang=ts&external"
export * from "./BillInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./BillInfo.vue?vue&type=style&index=0&id=7f8a00cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a00cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8a00cd')) {
      api.createRecord('7f8a00cd', component.options)
    } else {
      api.reload('7f8a00cd', component.options)
    }
    module.hot.accept("./BillInfo.vue?vue&type=template&id=7f8a00cd&scoped=true", function () {
      api.rerender('7f8a00cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/details/BillInfo/BillInfo.vue"
export default component.exports